module.exports = __webpack_public_path__ + "img/logo.83010d3d.jpg";